import { gsap } from "gsap";
import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { ICanvasScaler } from "../../../../../../canvas/ICanvasScaler";
import { HourlyBonusResourcePackage } from "../resources/HourlyBonusResourcePackage";

export class DicesBackground extends Container {
    private readonly ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>();
    private readonly canvasScaler: ICanvasScaler;
    private dicesIcons: Array<Sprite>;

    public constructor(
        wheelResources: HourlyBonusResourcePackage,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.canvasScaler = canvasScaler;
        this.ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>(
            { percentPosition: new Point(325, 107), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_01_png },
            { percentPosition: new Point(14, 221), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_02_png },
            { percentPosition: new Point(658, 255), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_03_png },
            { percentPosition: new Point(599, 586), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_04_png },
            { percentPosition: new Point(-115, 536), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_05_png },
            { percentPosition: new Point(63, 986), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_06_png },
            { percentPosition: new Point(611, 992), texture: wheelResources.assets_views_hourly_bonus_wheel_result_dice_07_png }
        );
        this.dicesIcons = [];
        this.build();
    }

    private build(): void {
        this.ICONS_VIEW_DESCRIPTION.forEach((item) => {
            const icon = new Sprite(item.texture);
            icon.position.set(item.percentPosition.x, item.percentPosition.y);
            this.dicesIcons.push(icon);
            this.addChild(icon);
        });
    }

    public async playStartAnimation(): Promise<void> {
        const size = this.canvasScaler.getSize();
        const animationTimeLine = new gsap.core.Timeline();
        this.dicesIcons.forEach(icon => {
            animationTimeLine.fromTo(icon, { x: size.width * 0.5, y: size.height * 0.5 }, { x: icon.x, y: icon.y, duration: 0.3 }, "<");
            animationTimeLine.fromTo(icon.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.3 }, "<");
        });
        animationTimeLine.then(() => {
            animationTimeLine.kill();
        });
    }

    public async hideDices(): Promise<void> {
        const size = this.canvasScaler.getSize();
        const animationTimeLine = new gsap.core.Timeline();
        this.dicesIcons.forEach(icon => {
            animationTimeLine.fromTo(icon, { x: icon.x, y: icon.y }, { x: size.width * 0.5, y: size.height * 0.5, duration: 0.4 }, "<");
            animationTimeLine.fromTo(icon.scale, { x: 1, y: 1 }, { x: 0, y: 0, duration: 0.4 }, "<");
        });
        animationTimeLine.then(() => {
            animationTimeLine.kill();
        });
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

type IconViewDescription = {
    percentPosition: Point;
    texture: Texture;
}